import { pl as reactpl } from '@ews/react-translations';

const pl = {
...reactpl
}
export default pl
